import React from "react";
import { Typography, Tag } from "components";
import { capitalizeFirstLetter, getDataCardColors } from "utils/helper";

const UserTypes = () => {

  const userTypes = [
    {
      name: "agent",
      title: "Managing terminal transactions",
      description:
        "They are the primary users of the system and they are enabled to view their terminal transactions and manage activities on their dashboard.",
    },
    {
      name: "aggregator",
      title: "Managing direct & downline terminals",
      description:
        "They are the secondary users and can manage both direct terminal and downline agents’ terminal transactions and activities.",
    },
    {
      name: "admin",
      title: "Managing all terminals & other functions",
      description:
        "Responsible for managing all terminal activities and authorization on the terminal management system.",
    },
  ];

  return (
    <div className="row user-types">
      {userTypes.map(({ name, description, title }, key) => {
        let colors = getDataCardColors(name);
        return (
          <div className="col-sm-6 col-md-4" key={key}>
            <div className={`edged-card edged-card--${name.toLowerCase()}`}>
              <Tag
                text={capitalizeFirstLetter(name)}
                backgroundColor={colors?.bgColor}
                textColor={colors?.textColor}
              />
               <Typography className={"mt-4"} variant="body2">
                {title}
              </Typography>
              <Typography className={"mt-2"} variant="body3" state="grey">
                {description}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserTypes;
